"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.button = exports.secondTicker = exports.firstTicker = exports.tickerContainer = exports.secondTickerKeyFrame = exports.firstTickerKeyFrame = exports.root = void 0;

var _util = require("../../../util");

const root = ({
  cssProps,
  theme
}) => {
  const {
    isPaused,
    tickerWidth = '100vw'
  } = cssProps;
  return {
    background: (0, _util.color)(theme, 'interactive.ticker.default'),
    height: 48,
    overflow: 'hidden',
    position: 'relative',
    width: tickerWidth,
    '&:hover *': {
      animationPlayState: 'paused'
    },
    '& *': {
      animationPlayState: isPaused ? 'paused' : 'running'
    }
  };
};

exports.root = root;

const firstTickerKeyFrame = () => ({
  '0%': {
    transform: 'translateX(0)'
  },
  '100%': {
    transform: 'translateX(-100%)'
  }
});

exports.firstTickerKeyFrame = firstTickerKeyFrame;

const secondTickerKeyFrame = () => ({
  '0%': {
    transform: 'translateX(0)'
  },
  '100%': {
    transform: 'translateX(-100%)'
  }
});

exports.secondTickerKeyFrame = secondTickerKeyFrame;

const tickerContainer = () => ({
  width: 'calc(100% - 48px)'
});

exports.tickerContainer = tickerContainer;

const firstTicker = ({
  cssProps
}) => {
  const {
    animation,
    paddingRight
  } = cssProps;
  return {
    animation: "".concat(animation, " 90s linear infinite"),
    transform: 'translateX(0)',
    paddingRight,
    willChange: 'transform'
  };
};

exports.firstTicker = firstTicker;

const secondTicker = ({
  cssProps
}) => {
  const {
    animation,
    paddingRight
  } = cssProps;
  return {
    animation: "".concat(animation, " 90s linear infinite"),
    transform: 'translateX(100%)',
    paddingRight,
    willChange: 'transform'
  };
};

exports.secondTicker = secondTicker;

const button = ({
  theme
}) => ({
  borderLeft: "1px solid ".concat((0, _util.color)(theme, 'background.white')),
  position: 'absolute',
  right: 0
});

exports.button = button;
//# sourceMappingURL=MarketSummaryTicker.style.js.map